const requireModule = require.context('.', true, /\.\/\w+(\/Component)?\.vue$/)
const modules = {}

requireModule.keys().forEach(fileName => {
  if (fileName.split('/').length > 3) return
  const moduleName = fileName.replace(/(\.\/|\.vue|\/Component.vue)/g, '')
  modules[moduleName] = requireModule(fileName).default
})

export default modules
